<template>
  <Modal
    :width="500"
    :visible="previewVisible"
    title="AI画图"
    cancelText="重新生成"
    okText="插入文章"
    @cancel="previewVisible = false"
  >
    <div class="operating-area">
      <el-form layout="vertical" :labelCol="{ span: 5, offset: 0 }">
        <el-form-item label="输入提示词" >
          <el-input type="textarea" v-model="content" placeholder="请输入" :rows="4" />
          <div class="flex" style="margin-top: 15px">
            <div style="width: 50px; text-align: right">尺寸：</div>
            <div class="flex1 sizes-block">
              <div class="size-item" v-for="(item, index) in sizes" :class="{'size-active': aspect_ratio === item.name}" :key="index" @click="selectSize(item.name)">
                {{ item.name }}
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item  v-if="aiData.messageList.length > 0">
          <div class="y-center" style="margin: 0px 0 10px" >
            <img
              src="@/assets/images/pop_shengchengjieguo@2x.png"
              style="width: 22px; height: 22px; margin-right: 4px"
            />
            <span>生成结果</span>
          </div>
          <div class="image-block flex-wrap">
            <img
              v-for="(item, index) in aiData.messageList"
              :key="index"
              mode="widthFix"
              class="image image-fit"
              :src="item"
            />
          </div>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <div class="x-end">
        <Button
          class="button none no-border"
          v-if="aiData.messageList.length > 0"
          :loading="aiData.loading"
          @click="onGenerate(2)"
        >
          <img
            src="@/assets/images/shuaxin@2x.png"
            style="width: 16px; height: 16px; margin-right: 4px"
          />
          <span>重新生成</span>
        </Button>
        <Button
          class="button"
          type="primary"
          :loading="aiData.loading"
          @click="onGenerate(1)"
          v-else
          >生成</Button
        >
        <Button class="button"  v-if="aiData.messageList.length > 0" @click="onInsertion"
          >插入文章</Button
        >
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal, Button, Spin, message } from "ant-design-vue";
import defHttp from "@/jslibs/axios/http";
import { useGlobSetting } from "@/hooks/setting";
// import generateImageW from './generateImageW.vue';
// import generateImageT from './generateImageT.vue';

const globSetting = useGlobSetting();
const ossUrl = globSetting.ossUrl;

export default {
  name: "AIDraw",
  components: {
    Modal,
    Button,
    Spin,
  },
  props: {
    insertion: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      aspect_ratio: "1:1",
      sizes: [
        {
          name: "1:1",
        },
         {
          name: "3:4",
        },
         {
          name: "4:3",
        },
         {
          name: "16:9",
        },
         {
          name: "9:16",
        }
        ,
         {
          name: "2:3",
        },

      ],
      content:"",
      imagineNum: {},
      previewVisible: false,
      aiData: {
        modelList: [
          { name: "应用生图", value: "txt2img.sd" },
          { name: "高级生图", value: "img2img.sd" },
        ],
        modelIndex: 0,
        previewVisible: false,
        drawStyle: [],
        more: true,
        dataIndex: 0,
        num: 1,
        task_type: "txt2img.sd",
        text: "",
        negative_prompt: "",
        err_text: "",
        err_text1: "",
        navList: [
          { name: "1:1", value: [1024, 1024] },
          { name: "3:4", value: [1024, 1048] },
          { name: "4:3", value: [1408, 1024] },
        ],
        navIndex: 0,
        params: {
          text: "",
          url: "",
          w: 512,
          h: 512,
          fidelity: 0.2,
          num_steps: 20,
          negative_prompt: "",
          style_uuid: "",
        },
        draw_uuid: "",
        title: "",
        loading: false,
        messageList: [],
      },
    };
  },
  methods: {
    selectSize(val){
      this.aspect_ratio = val
    },
    isLoading(isT) {
      this.aiData.loading = isT;
    },
    getImg(obj) {
      this.aiData.messageList = obj.urls;
      this.aiData.draw_uuid = obj.uuid;
    },
    beforeUpload(file) {
      const isType = file.type === "image/jpeg" || file.type === "image/png";
      if (!isType) {
        message.warning("仅支持上传图片");
      }
      const isLtSize = file.size / 1024 / 1024 < 20;
      if (!isLtSize) {
        message.warning("请勿上传大小超过20MB的文件");
      }
      return isType && isLtSize;
    },
    handleChange(info) {
      if (info.file.status === "done") {
        const name = info.file.name;
        const file_url = info.file.response.result;
        const file_name = name.substring(0, name.lastIndexOf("."));
        const file_type = name.substring(name.lastIndexOf(".") + 1);
        this.aiData.fileList = [
          {
            name,
            file_name,
            file_type,
            status: "done",
            url: ossUrl + file_url,
          },
        ];
        this.aiData.params.url = ossUrl + file_url;
      }
    },
    onAdd() {
      if (this.aiData.num >= 10) {
        return false;
      }
      this.aiData.num += 1;
    },
    onSub() {
      if (this.aiData.num <= 1) {
        return false;
      }
      this.aiData.num -= 1;
    },
    onDownLoad(data) {
      const url = data.img_urls && data.img_urls[0];
      if (url) {
        window.open(url);
      }
      // var link = document.createElement('a');
      // link.href = filePath;
      // link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
      // link.click();
    },
    getAiDrawStyle() {
      return defHttp
        .get({
          url: `/v1/cms/AiDrawStyle`,
        })
        .then((res) => {
          this.aiData.drawStyle = res.result;
        });
    },
    async onGenerate(option_type = 1) {
      if (this.aiData.loading) return message.warning('正在生成中...');
      this.aiData.messageList = [];
      
    if(this.content == '') return message.warning(`请输入提示词`);
      this.aiData.loading = true;
      defHttp
        .post(`/cms/AiContent/image`, {
           aspect_ratio: this.aspect_ratio,
           content: this.content
          })
        .then((res) => {
           this.aiData.messageList = [res.data.result];
            this.aiData.loading = false;
        })
        .catch(() => {
          this.aiData.loading = false;
        });
    },
    onInsertion() {
      if (this.aiData.loading) return message.warning("正在生成中...");
      if (this.aiData.messageList.length === 0)
        return message.warning(`请生成图片`);
      const array = [];
      this.aiData.messageList.forEach((item) => {
        array.push(
          `<img src="${item}" style="width: 100%;object-fit: contain;" />`
        );
      });
      this.$emit("onAiDraw", array.join(), "insertion");
      this.$emit("onAiDrawNo", this.aiData.messageList);
      this.previewVisible = false;
    },
    onModelSwitch(index) {
      if (this.aiData.loading) return message.warning("正在生成中...");
      this.aiData.modelIndex = index;
      this.aiData.messageList = [];
    },
    onShow(params) {
      const show = params && params.show;
      this.previewVisible =
        Object.prototype.toString.call(show) === "[object Boolean]"
          ? show
          : true;
      // this.getAiDrawStyle().then(() => {
      //   const { model = '', num, text = '', fn } = params;
      //   console.log(params);
      //   if (model) {
      //     const index = this.aiData.drawStyle.findIndex((m) => m.model === model);
      //     this.aiData.dataIndex = index;
      //     this.aiData.num = num || 1;
      //     this.aiData.text = text;
      //     this.onGenerate(1);
      //     fn && fn();
      //   }
      // });
      // this.getImagineNum();
    },
    getImagineNum() {
      defHttp
        .get({
          url: `/v1/cms/GetImagineNum`,
        })
        .then((res) => {
          this.imagineNum = res.result;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.sizes-block{
  display: flex;
  justify-content: start;
  gap: 10px
}
.size-active{
  background: rgba(116,114,246,0.104)!important;
  color: #7472F6!important;
}
.size-item{
  min-width: 44px;
height: 32px;
cursor: pointer;
line-height: 32px;
text-align: center;
font-weight: 350;
font-size: 16px;
border-radius: 4px;
color: #000000;
background: #F6F6F6;
}
.operating-area {
  padding: 20px;

  .operating-block {
    width: 552px;
    height: 36px;
    margin-top: 20px;
    margin-bottom: 20px;
    // background: #f5f5f5;
    padding: 0;
    border-bottom: 1px solid #f1f1f1;
  }

  .data-item {
    position: relative;
    box-sizing: border-box;
    width: 100px;
    height: 100px;
    margin-right: 12px;
    margin-bottom: 12px;
    overflow: hidden;
    border-radius: 8px;
    background-size: 100% 100%;
    color: #fff;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    cursor: pointer;

    // &::after {
    //   content: ' ';
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   width: 100px;
    //   height: 100px;
    //   background: rgba(0, 0, 0, 0.38);
    //   border-radius: 8px;
    //   z-index: 1;
    // }
    .text {
      position: absolute;
      z-index: 2;
    }

    &.active {
      border: 3px solid #7472f6;
    }
  }

  .data-item1 {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    background: #f6f6f6;
    color: #222;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      margin-bottom: 4px;
    }
  }

  .packup {
    width: 540px;
    height: 36px;
    border-radius: 18px;
    background: #f6f6f6;
    color: #222;
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    cursor: pointer;
  }

  .nav-item {
    height: 30px;
    margin-right: 10px;
    padding: 0 20px;
    border-radius: 3px;
    background: #f6f6f6;
    color: #000;
    font-size: 14px;
    cursor: pointer;

    &.active {
      background: #7472f6;
      color: #fff;
      font-weight: 500;
    }
  }

  .size-block {
    margin-top: 20px;

    .button {
      min-width: auto;
      height: 32px;
      margin-right: 20px;
    }
  }

  .upload-tip {
    margin-top: 10px;
    color: #666;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }
}

.image-block {
  .image {
    width: 100%;
    // height: 180px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 4px;
    object-fit: cover;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}

.checkbox-list {
  .checkbox-item {
    height: 30px;
    margin-right: 10px;
    padding: 0 20px;
    border: 1px solid #000;
    border-radius: 6px;
    background: #fff;
    color: rgb(102 102 102 / 90%);
    font-family: PingFangSC-Regular, "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;

    &.active {
      border-radius: 6px;
      background: #7472f6;
      color: #fff;
      font-weight: 500;
    }
  }
}

.tips {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
  font-weight: 400;
}
</style>
